import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPencil(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.2839 2.11612C19.0495 1.8817 18.7315 1.75 18.4 1.75C18.0685 1.75 17.7506 1.8817 17.5161 2.11612L3.51614 16.1161C3.34164 16.2906 3.22269 16.5129 3.17429 16.7549L1.77429 23.7549C1.69233 24.1647 1.82061 24.5884 2.11614 24.8839C2.41167 25.1794 2.83534 25.3077 3.24517 25.2257L10.2452 23.8257C10.4872 23.7773 10.7094 23.6584 10.8839 23.4839L24.8839 9.48388C25.3721 8.99573 25.3721 8.20427 24.8839 7.71612L19.2839 2.11612ZM22.2323 8.6L19.8 11.0322L15.9678 7.2L18.4 4.76777L22.2323 8.6ZM18.0323 12.8L14.2 8.96777L5.55152 17.6163L4.59346 22.4066L9.38376 21.4485L18.0323 12.8Z"
        clipRule="evenodd"
      />
      <path fill="currentColor" d="M30.25 26.75H1.75V29.25H30.25V26.75Z" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
